export enum RelationshipEnum {
  COWORKER = 'COWORKER',
  FRIEND = 'FRIEND',
  OTHER = 'OTHER',
  RELATIVE = 'RELATIVE',
  SPOUSE = 'SPOUSE',
}
